import { useContext, useState } from 'react'
import ConfirmAlert from '../../../components/confirmAlert'
import { DomainContext } from '../../../context/DomainContext'
import { succToast } from '../../../utils'

export const useBaseHook = (api) => {
    const { setLoading, ToggleReloadTable } = useContext(DomainContext)
    const [isLoading, setIsLoading] = useState(false)
    const onApply = (msg, reqBody, action) => {

        setIsLoading(true)
        ConfirmAlert(msg,
            () => {
                setLoading(l => l + 1)
                api?.(reqBody)?.then(res => {
                    action?.()
                        
                    ToggleReloadTable(prev => !prev)
                    succToast("Operation done successfully")
                })?.finally(() => {
                    setLoading(l => l - 1)
                    setIsLoading(false)
                }
                )
            })
    }

    return { onApply, isLoading }
}
